import { CircleCheckBig, Stethoscope } from "lucide-react";
import { Reveal } from "./shared";

export const About = () => (
  <section id="about" className="px-4 py-24 sm:px-6 lg:px-8" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <Reveal className="relative max-w-md">
        <div className="absolute -top-8 -left-8 h-64 w-64 rounded-full bg-[#1E7B4F]/10 blur-3xl" />
        <div className="relative overflow-hidden rounded-3xl border border-[#E7E3D9] bg-white shadow-xl">
          <img
            src="/images/dr-sam-garner.jpeg"
            alt="Dr Sam Garner, founder of Desk to Defib, providing medical cover at a stadium event"
            className="h-auto w-full object-cover"
          />
        </div>
        <div className="absolute bottom-4 left-4 rounded-xl border border-[#E7E3D9] bg-white/95 p-4 shadow-lg backdrop-blur">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1E7B4F]/10">
              <Stethoscope className="h-5 w-5 text-[#1E7B4F]" />
            </div>
            <div>
              <p className="text-sm font-semibold text-[#14231B]">Dr Sam Garner</p>
              <p className="text-xs text-[#5F6E63]">Founder</p>
            </div>
          </div>
        </div>
      </Reveal>
      <div>
        <Reveal>
          <h2 className="font-display text-3xl font-bold tracking-tight text-[#14231B] sm:text-4xl lg:text-5xl">
            First aid, <span className="text-[#1E7B4F]">made practical</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[#5F6E63]">
            Desk to Defib was founded by Dr Sam Garner, a doctor who also provides medical cover at
            large-scale events. Every session is delivered by a doctor — sharing what emergencies
            actually look and feel like, and how simple, early actions save lives.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-[#5F6E63]">
            The goal is simple: give more people the confidence to step in during cardiac arrest and
            other emergencies — starting in workplaces, one hour at a time.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <ul className="mt-8 space-y-4">
            {[
              "Every session delivered by a doctor",
              "Real-world perspective from frontline and event medicine",
              "Friendly, practical teaching — no question too small",
            ].map((t) => (
              <li key={t} className="flex items-center gap-3">
                <CircleCheckBig className="h-5 w-5 shrink-0 text-[#F97316]" />
                <span className="text-base font-medium text-[#14231B]">{t}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
